import { ModelBase } from '../../core/model/model-base';

export interface ProtectedIdentityContact {
  canActivate: boolean;
  name: string;
  civicNumber: string;
  sessionSecondsRemaining: number;
}

export interface ProtectedIdentityContactForm {
  name: string;
  civicNumber: string;
}

export interface ProtectedIdentityAccess {
  hasAccess: boolean;
  sessionSecondsRemaining: number;
}

export class IdentityLog extends ModelBase {
  userName: string;
  eventType: string;
  eventTranslation: string;
  createdAt: string;
}

export interface IdentityLogPageRequest {
  page: number;
  pageSize: number;
  orderBy?: string;
  descending: boolean;
}
